export enum MenuPlacementType {
  TOP = 'TOP',
  ASIDE = 'ASIDE',
}

export type AppLayout = {
  menuPlacement: MenuPlacementType;
  windowWidth: number;
  windowHeight: number;
  containerWidth: number;
  containerHeight: number;
  offset: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
};

export const STUDENT_APP_BUTTON_SIZES = {
  default: 64,
  small: 58,
};

export const STUDENT_APP_DEFAULT_PADDING = {
  x: 24,
  y: 24,
};
